export default __webpack_public_path__ + "static/media/project-status-pending-payment.4ca1754b.svg";